import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InnerPageLayoutComponent } from '../inner-page-layout/inner-page-layout.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-menu',
    template: `
        <div class="layout-menu-container">
            <ul class="layout-menu" role="menu" (keydown)="onKeydown($event)">
                <li app-menu class="layout-menuitem-category" *ngFor="let item of model; let i = index;" role="none">
                    <div class="layout-menuitem-root-text" [attr.aria-label]="item.label">{{item.label}}</div>
                    <ul role="menu">
                        <li app-menuitem *ngFor="let child of item.items" [item]="child" [index]="i" role="none"></li>
                    </ul>
                </li>
            </ul>
        </div>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(public appMain: InnerPageLayoutComponent, private router: Router, public translate: TranslateService) {
        this.translate.onLangChange.subscribe((event: any) => {
             this.prepareMenu()

        })
     }
    async ngOnInit() { 
        this.prepareMenu()
        // sessionStorage.setItem("isFarmerLogin", '1');
    }
    async prepareMenu(){
        await this.translate.get('dummyTranslation').toPromise().then();
        let AtalbhujalRole: any = sessionStorage.getItem('isAtalBhujal');
        let FarmerRole: any = sessionStorage.getItem('isFarmerLogin');
        let deptUserId: any = sessionStorage.getItem('deptUserID');
        let userRole: any = sessionStorage.getItem('userRole');
        // console.log(userRole,'userRole')
        if (AtalbhujalRole == "1" && FarmerRole != "1") {
            this.model = [
                {
                    label: 'Home',
                    items: [
                        { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'] },
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/department')) {
            if (deptUserId == 'D.A-1'||deptUserId == 'D.A-2'||deptUserId == 'D.A-3'||deptUserId == 'D.A-4'||deptUserId == 'D.A-5'||deptUserId == 'D.A-6'||deptUserId == 'D.A-7'||deptUserId == 'D.A-8') {
                this.model = [
                    {
                        label: this.translate.instant('APPLICATION_&_ESTIMATE_APPROVAL'),
                        items: [
                            // { label: 'Dashboard', icon: 'pi pi-fw pi-id-card', routerLink: ['/department'] },
                            { label:  this.translate.instant("FARMER_APPLICATIONS_FOR_APPROVAL"),  icon: 'pi pi-fw pi-id-card', routerLink: ['/department/farmer-applications'] },
                            { label: this.translate.instant('Vendor_MI_ESTIMATES_FOR_APPROVAL_MI'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/vendor-mi-applications'] },
                            // { label: 'Print Farmer Bank Challan', icon: 'pi pi-fw pi-id-card', routerLink: ['/department/print-farmer-bank-challan']},
                            // { label: 'Approve Farmer Bank Challan', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/department/approve-farmer-bank-challan']},
                            { label: this.translate.instant('UPDATE_MI_COMPONENT_CML_VALIDITY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/update-mi-component-cml-validity'] },
                            // {label: 'Bank Details', icon: 'pi pi-fw pi-check-square', routerLink: ['/bank-details']},
                            // {label: 'Farmers Land Details', icon: 'pi pi-fw pi-bookmark', routerLink: ['/farmer-land-detail']},
                            // {label: 'On-Farm MI', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/on-farm-mi']}
                        ],
                    },
                    // {
                    //     label: this.translate.instant('PHYSICAL_VERIFICATION'),
                    //     items: [
                    //         { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                    //         { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                    //         { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                    //         { label: this.translate.instant('TANK_STAGE3_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },
                            
                    //     ]
                    // },
                    // {
                    //     label : 'Change Request',
                    //     items: [
                    //         { label: 'Farmer Applications For Change Request', icon: 'pi pi-fw pi-id-card', routerLink: ['/department/change-request'] },
                    //     ]
                    // },
                    {
                        label: this.translate.instant('REPORT'),
                        items: [
                            { label: this.translate.instant('APPLICATION_ABSTRACT_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report-summary'] },
                        ],
                    },
                    {
                        label: this.translate.instant('HELPDESK'),
                        items: [
                                { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/helpdesk'] },
                         ],
                    },
                    {
                        label: this.translate.instant('REPORTS'),
                        items: [
                            { label: this.translate.instant('APP_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/app-verification'] },
                            { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation'] },
                            { label: this.translate.instant('VENDOR_ESTIMATION_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation-verification'] },
                            { label: this.translate.instant('CHALLAN_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/challan'] },
                            { label: this.translate.instant('BILL_OF_QUANTITY_SUBMISSION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/boq'] },
                            { label: this.translate.instant('APP_PHYSCICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/physical-verification'] },
                            { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/fsv'] },
                            { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stv'] },
                            { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stf'] },
                            { label: this.translate.instant('RETURN_OF_EXCESS_FARMER_SHARE_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/rtf'] },
                            { label: this.translate.instant('MI_VERIFICATION_SUBSIDY_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/mi-verification-subsidy-report'] },
                            { label: this.translate.instant('TANK_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/tank-abstract-report'] },
                            { label: this.translate.instant('TANK_STAGE1'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-report'] },
                            { label: this.translate.instant('TANK_STAGE2'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-report'] },
                            { label: this.translate.instant('TANK_STAGE3'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-report'] },
                            { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-subsidy-report'] },
                            { label: this.translate.instant('CANAL_AND_TUBE_WELL_BASED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/canal-and-tube-well-based-report'] },
                            { label: this.translate.instant('7500_DEMO'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/7500-demo'] },
                            { label: this.translate.instant('ATAL_BHUJAL_USER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/atal-bhujal-user'] },
                        ]
                    },
                    {
                        label: this.translate.instant('MICADA_1.0_DATA'),
                        items: [
                            { label: this.translate.instant('MI_PHYSICAL_LOCATION'), icon: 'pi pi-fw pi-bookmark', routerLink: ['mi-physical-location']}
                        ]
                    }
                ];

                if(deptUserId == 'D.A-3'){
                    this.model.splice(1, 0, {
                        label: this.translate.instant('PHYSICAL_VERIFICATION_OF_MI_&_TANK'),
                        items: [
                            { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                            // { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                            { label: this.translate.instant('TANK_STAGE2_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                            { label: this.translate.instant('TANK_STAGE3_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },
                            
                        ]
                    })
                }
                // else if(deptUserId == 'D.A-9'){
                //     this.model.splice(1, 0, {
                //         label: this.translate.instant('PHYSICAL_VERIFICATION'),
                //         items: [
                //             { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                //             { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                //             // { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                //             // { label: this.translate.instant('TANK_STAGE3_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },
                            
                //         ]
                //     })
                // }
                else{
                    this.model.splice(1, 0, {
                        label: this.translate.instant('PHYSICAL_VERIFICATION_OF_MI_&_TANK'),
                        items: [
                            { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                            // { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                            // { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                            // { label: this.translate.instant('TANK_STAGE3_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },
                            
                        ]
                    })
                }
            } else if(deptUserId == 'D.A-9') {
                // if (userRole == "DD") {
                this.model = [
                    {
                        label: this.translate.instant('PHYSICAL_VERIFICATION'),
                        items: [
                            { label: this.translate.instant('TANK_STAGE1_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                    ]
                },
                {
                    label: this.translate.instant('REPORT'),
                    items: [
                        { label: this.translate.instant('APPLICATION_ABSTRACT_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report-summary'] },
                    ],
                },
                {
                    label: this.translate.instant('HELPDESK'),
                    items: [
                            { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/helpdesk'] },
                     ],
                },
            ]
        // }
        } else {
                if (userRole != "ADVISOR"){
                this.model = [
                    {
                        label: this.translate.instant('APPLICATION_&_ESTIMATE_APPROVAL'),
                        items: [
                            // { label: 'Dashboard', icon: 'pi pi-fw pi-id-card', routerLink: ['/department'] },
                            { label: this.translate.instant("FARMER_APPLICATIONS_FOR_APPROVAL"), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/farmer-applications'] },
                            { label: this.translate.instant('Vendor_MI_ESTIMATES_FOR_APPROVAL_MI'), icon: 'pi pi-fw pi-check-square', routerLink: ['/department/vendor-mi-applications'] },
                            // { label: 'Print Farmer Bank Challan', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/department/print-farmer-bank-challan']},
                            // { label: 'Approve Farmer Bank Challan', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/department/approve-farmer-bank-challan']},
                        ],
                    },
                    {
                        label: this.translate.instant('PHYSICAL_VERIFICATION_OF_MI_&_TANK'),
                        items: [
                            { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                            { label: this.translate.instant('TANK_STAGE1_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                            { label: this.translate.instant('TANK_STAGE2_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                            { label: this.translate.instant('TANK_STAGE3_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },    
                        ]
                    },
                    // {
                    //     label : 'Change Request',
                    //     items: [
                    //         { label: 'Farmer Applications For Change Request', icon: 'pi pi-fw pi-id-card', routerLink: ['/department/change-request'] },
                    //     ]
                    // },
                    {
                        label: this.translate.instant('REPORT'),
                        items: [
                            { label: this.translate.instant('APPLICATION_ABSTRACT_REPORT'), icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/department/report-summary'] },
                        ],
                    },
                    {
                        label: this.translate.instant('HELPDESK'),
                        items: [
                                { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/helpdesk'] },
                            ],
                    },
                    {
                        label: this.translate.instant('CM_DASHBOARD'),
                        items: [
                                { label:this.translate.instant('YEAR_WISE_PROGRESS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/year-wise-progress'] },
                                { label:this.translate.instant('MI_AREA_COVERED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/mi-area-covered'] },
                                { label:this.translate.instant('REAL_TIME_DATA_OF_PDMC_SCHEME'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/realtime-data-pdmc-scheme'] }
                            ],
                    }
                ];
                }
            }
            // if (userRole == "DD Associate") {
            //     this.model.push(
            //         {
            //             label: 'Helpdesk',
            //             items: [
            //                 { label: 'Application Status', icon: 'pi pi-fw pi-id-card', target: '_blank', routerLink: ['/helpdesk/home'] },
            //             ]
            //         }
            //     )
            // }
            if (userRole == "DMICADA") {
                this.model.splice(1, 1, {
                    label: this.translate.instant('PHYSICAL_VERIFICATION_OF_MI_&_TANK'),
                    items: [
                        { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/physical-verification'] },
                        { label: this.translate.instant('TANK_STAGE1_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage1'] },
                        { label: this.translate.instant('TANK_STAGE2_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage2'] },
                        { label: this.translate.instant('TANK_STAGE3_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tank-stage3'] },    
                        { label: this.translate.instant('MAPS_FIELD_SURVEY_MAP_VIEW'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/maps'] },
                    ]
                })
                this.model.push(
                    {
                        label: this.translate.instant('FARMER_SHARE'),
                        items: [
                            { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-bookmark', target: '_blank', routerLink: ['/department/farmer-share-to-vendor'] },
                        ]
                    },
                    {
                        label: this.translate.instant('SUBSIDY_LOT'),
                        items: [
                            { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-bookmark', target: '_blank', routerLink: ['/department/subsidy-to-farmer'] },
                            { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-bookmark', target: '_blank', routerLink: ['/department/subsidy-to-vendor'] },
                            { label: this.translate.instant('REFUND_TO_FARMER'), icon: 'pi pi-fw pi-bookmark', target: '_blank', routerLink: ['/department/refund-to-farmer'] },
                            { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tankstage-1'] },
                            { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tankstage-2'] },
                            { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/pond/tankstage-3'] },
                            { label: this.translate.instant('VIEW_ALL_SUBSIDY_LOT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/all-subsidy-lot'] },
                        ]
                    },
                    // {
                    //     label: this.translate.instant('MAPS'),
                    //     items: [
                    //         { label: this.translate.instant('FIELD_SURVEY_MAP_VIEW'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/maps'] },
                    //     ]
                    // },
                    {
                        label: this.translate.instant('DASHBOARDS'),
                        items: [
                            { label: this.translate.instant('MICADA_GEOGRAPHY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/micada_geography']},
                            { label: this.translate.instant('VENDOR_METRICS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/vendor_metrics']},
                            { label: this.translate.instant('APPLICATION_VERIFICATION_SINGLE_VIEW'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/app_verification']},
                        ]
                    },
                    {
                        label: this.translate.instant('REPORTS'),
                        items: [
                            { label: this.translate.instant('TIME_LINE'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/timeline'] },
                            { label: this.translate.instant('MI_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/consolidated-report'] },
                            { label: this.translate.instant('POND_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/pond-consolidated-report'] },
                            { label: this.translate.instant('APP_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/app-verification'] },
                            { label: this.translate.instant('VENDOR_PRE_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/pre-estimation'] },
                            { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation'] },
                            { label: this.translate.instant('VENDOR_ESTIMATION_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation-verification'] },
                            { label: this.translate.instant('CHALLAN_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/challan'] },
                            { label: this.translate.instant('BILL_OF_QUANTITY_SUBMISSION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/boq'] },
                            { label: this.translate.instant('APP_PHYSCICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/physical-verification'] },
                            { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/fsv'] },
                            { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stv'] },
                            { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stf'] },
                            { label: this.translate.instant('RETURN_OF_EXCESS_FARMER_SHARE_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/rtf'] },
                            { label: this.translate.instant('MI_VERIFICATION_SUBSIDY_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/mi-verification-subsidy-report'] },
                            { label: this.translate.instant('VENDOR_MI_AREA'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/vendor-mi-area-report'] },
                            { label: this.translate.instant('TANK_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/tank-abstract-report'] },
                            { label: this.translate.instant('TANK_STAGE1'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-report'] },
                            { label: this.translate.instant('TANK_STAGE2'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-report'] },
                            { label: this.translate.instant('TANK_STAGE3'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-report'] },
                            { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-subsidy-report'] },
                            { label: this.translate.instant('CANAL_AND_TUBE_WELL_BASED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/canal-and-tube-well-based-report'] },
                            { label: this.translate.instant('CHALLAN_RECONCILIATION_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/chalan-reconciliation-day-report'] },
                            { label: this.translate.instant('7500_DEMO'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/7500-demo'] },
                            { label: this.translate.instant('ATAL_BHUJAL_USER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/atal-bhujal-user'] },
                            { label: this.translate.instant('DA_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/da-report'] },
                        ]
                    },
                    {
                        label: this.translate.instant('MICADA_1.0_DATA'),
                        items: [
                            { label: this.translate.instant('MI_PHYSICAL_LOCATION'), icon: 'pi pi-fw pi-bookmark', routerLink: ['mi-physical-location']}
                        ]
                    }
                )
            }
            if (userRole == "ADVISOR"){
                this.model=[
                    {
                        label: this.translate.instant('DASHBOARDS'),
                        items: [
                            { label: this.translate.instant('MICADA_GEOGRAPHY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/micada_geography']},
                            { label: this.translate.instant('VENDOR_METRICS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/vendor_metrics']},
                            { label: this.translate.instant('APPLICATION_VERIFICATION_SINGLE_VIEW'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/dashboard/app_verification']},
                        ]
                    },
                    {
                        label: this.translate.instant('REPORTS'),
                        items: [
                            { label: this.translate.instant('TIME_LINE'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/timeline'] },
                            { label: this.translate.instant('MI_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/consolidated-report'] },
                            { label: this.translate.instant('POND_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/pond-consolidated-report'] },
                            { label: this.translate.instant('APP_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/app-verification'] },
                            { label: this.translate.instant('VENDOR_PRE_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/pre-estimation'] },
                            { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation'] },
                            { label: this.translate.instant('VENDOR_ESTIMATION_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/estimation-verification'] },
                            { label: this.translate.instant('CHALLAN_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/challan'] },
                            { label: this.translate.instant('BILL_OF_QUANTITY_SUBMISSION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/boq'] },
                            { label: this.translate.instant('APP_PHYSCICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/physical-verification'] },
                            { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/fsv'] },
                            { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stv'] },
                            { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stf'] },
                            { label: this.translate.instant('RETURN_OF_EXCESS_FARMER_SHARE_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/rtf'] },
                            { label: this.translate.instant('MI_VERIFICATION_SUBSIDY_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/mi-verification-subsidy-report'] },
                            { label: this.translate.instant('VENDOR_MI_AREA'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/vendor-mi-area-report'] },
                            { label: this.translate.instant('TANK_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/tank-abstract-report'] },
                            { label: this.translate.instant('TANK_STAGE1'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-report'] },
                            { label: this.translate.instant('TANK_STAGE2'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-report'] },
                            { label: this.translate.instant('TANK_STAGE3'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-report'] },
                            { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage1-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage2-subsidy-report'] },
                            { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/stage3-subsidy-report'] },
                            { label: this.translate.instant('CANAL_AND_TUBE_WELL_BASED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/canal-and-tube-well-based-report'] },
                            { label: this.translate.instant('CHALLAN_RECONCILIATION_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/chalan-reconciliation-day-report'] },
                            { label: this.translate.instant('7500_DEMO'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/7500-demo'] },
                            { label: this.translate.instant('ATAL_BHUJAL_USER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/report/atal-bhujal-user'] },
                        ]
                    },
                    {
                        label: this.translate.instant('CM DASHBOARD'),
                        items: [
                                { label:this.translate.instant('YEAR_WISE_PROGRESS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/year-wise-progress'] },
                                { label:this.translate.instant('MI_AREA_COVERED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/mi-area-covered'] },
                                { label:this.translate.instant('REAL_TIME_DATA_OF_PDMC_SCHEME'), icon: 'pi pi-fw pi-id-card', routerLink: ['/department/realtime-data-pdmc-scheme'] }
                            ],
                    }
                ]
                
            }
        }
        else if (this.router.url.startsWith('/vendor')) {
            this.model = [
                // {
                //     label: 'Vendor',
                //     items: [
                //         { label: 'Dashboard', icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor'] },
                //         // {label: 'Bank Details', icon: 'pi pi-fw pi-check-square', routerLink: ['/bank-details']},
                //         // {label: 'Farmers Land Details', icon: 'pi pi-fw pi-bookmark', routerLink: ['/farmer-land-detail']},
                //         // {label: 'On-Farm MI', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/on-farm-mi']}
                //     ]
                // }
                {
                    label: this.translate.instant('HOME'),
                    items: [
                        { label: this.translate.instant('PRE_ESTIMATE_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-book', routerLink: ['/vendor/pre-estimate-survey'] },
                        { label: this.translate.instant('7500_Applications'), icon: 'pi pi-fw pi-home', routerLink: ['/vendor/dashboard'] },
                        { label: this.translate.instant('FARMER_APPLICATION_HEADER'), icon: 'pi pi-fw pi-home',routerLink: ['/vendor/vendor-farmer-application'] },
                        // {label: 'Pond Progress Intimation',icon: 'pi pi-fw pi-book', routerLink: ['/pond-progress-intimation']}
                    ]
                },
                {
                    label: this.translate.instant('APPLIACTION'),
                    items: [
                        { label: this.translate.instant('MI_ESTIMATION_HEADER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor/vendor-application'] },
                        { label: this.translate.instant('MI_BOQ_DETAILS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor/vendor-BOQ'] },
                    ]
                },
                {
                    label: this.translate.instant('PURCHASE_AND_GST_CERTIFICATE'),
                    items: [
                        { label: this.translate.instant('MI_COMPONENT_INVETORY_DETAILS'), icon: 'pi pi-fw pi-check-square', routerLink: ['/vendor/mi-component-inventory-details']},
                        { label: this.translate.instant('UPLOAD_GST_DETAILS'), icon: 'pi pi-fw pi-check-square', routerLink: ['/vendor/upload-gst-details']}
                    ]
                },
                
                // {
                //     label: this.translate.instant('PRE_ESTIMATE_SURVEY'),
                //     items: [
                //         { label: this.translate.instant('PRE_ESTIMATE_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-book', routerLink: ['/vendor/pre-estimate-survey'] }
                //     ]
                // },
                {
                    label: this.translate.instant('CHALLAN'),
                    items: [
                        { label: this.translate.instant('FARMER_FULL_PAYMENT_INTIMATION_DETAILS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor/vendor-FullPaymentChallanDetails'] },
                    ]
                },
                {
                    label: this.translate.instant('REPORTS'),
                    items: [
                        { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor/report/estimation'] },
                        
                        { label: this.translate.instant('VENDOE_MI_AREA'), icon: 'pi pi-fw pi-id-card', routerLink: ['/vendor/report/vendor-mi-area-report'] },
                        
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/je')) {
            this.model = [
                {
                    label: this.translate.instant('JE'),
                    items: [
                       // { label: 'Tank Stage Verification', icon: 'pi pi-fw pi-id-card', routerLink: ['/je'] },
                        { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/je/physical-verification'] },
                        { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['je/tank-stage1'] },
                        { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['je/tank-stage2'] },
                        // { label: 'Tank Stage-3 Survey', icon: 'pi pi-fw pi-id-card', routerLink: ['je/tank-stage3'] },
                        // {label: 'Bank Details', icon: 'pi pi-fw pi-check-square', routerLink: ['/bank-details']},
                        // {label: 'Farmers Land Details', icon: 'pi pi-fw pi-bookmark', routerLink: ['/farmer-land-detail']},
                        // {label: 'On-Farm MI', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/on-farm-mi']}
                    ]
                },
                {
                    label: this.translate.instant('MICADA_1.0_DATA'),
                    items: [
                        { label: this.translate.instant('MI_PHYSICAL_LOCATION'), icon: 'pi pi-fw pi-bookmark', routerLink: ['mi-source-location']}
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/cje')) {
            this.model = [
                {
                    label: this.translate.instant('CJE'),
                    items: [
                        { label: this.translate.instant('MI_PHYSICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/cje/physical-verification'] },
                        // { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['je/tank-stage1'] },
                        // { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['je/tank-stage2'] },
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/helpdesk')) {
            // this.model = [
            //     {
            //         label: 'Helpdesk',
            //         items: [
            //             { label: 'Application Status', icon: 'pi pi-fw pi-id-card', routerLink: ['/helpdesk/home'] },
            //         ]
            //     }
            // ];
            this.model = [
                {
                    label: this.translate.instant('HELPDESK'),
                    items: [
                        // { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['department/helpdesk'] },
                        { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/helpdesk/home'] },
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/sdo')) {
            this.model = [
                {
                    label: this.translate.instant('SDO'),
                    items: [
                        { label: this.translate.instant('MI_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/sdo'] },
                        { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['sdo/tank-stage1'] },
                        { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['sdo/tank-stage2'] },
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/xen')) {
            this.model = [
                {
                    label: this.translate.instant('XEN'),
                    items: [
                        { label: this.translate.instant('MI_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen'] },
                        { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['xen/tank-stage1'] },
                        { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['xen/tank-stage2'] },
                    ]
                },
                {
                    label: this.translate.instant('HELPDESK'),
                    items: [
                            { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/helpdesk'] },
                     ],
                },
                {
                    label: this.translate.instant('REPORTS'),
                    items: [
                        { label: this.translate.instant('APP_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/app-verification'] },
                        { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/estimation'] },
                        { label: this.translate.instant('VENDOR_ESTIMATION_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/estimation-verification'] },
                        { label: this.translate.instant('CHALLAN_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/challan'] },
                        { label: this.translate.instant('BILL_OF_QUANTITY_SUBMISSION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/boq'] },
                        { label: this.translate.instant('APP_PHYSCICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/physical-verification'] },
                        { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/fsv'] },
                        { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stv'] },
                        { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stf'] },
                        { label: this.translate.instant('RETURN_OF_EXCESS_FARMER_SHARE_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/rtf'] },
                        { label: this.translate.instant('MI_VERIFICATION_SUBSIDY_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/mi-verification-subsidy-report'] },
                        { label: this.translate.instant('TANK_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/tank-abstract-report'] },
                        { label: this.translate.instant('TANK_STAGE2'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage2-report'] },
                        { label: this.translate.instant('TANK_STAGE3'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage3-report'] },
                        { label: this.translate.instant('TANK_STAGE1'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage1-report'] },
                        { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage1-subsidy-report'] },
                        { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage2-subsidy-report'] },
                        { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/stage3-subsidy-report'] },
                        { label: this.translate.instant('CANAL_AND_TUBE_WELL_BASED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/xen/report/canal-and-tube-well-based-report'] },
                    ]
                },
                {
                    label: this.translate.instant('MICADA_1.0_DATA'),
                    items: [
                        { label: this.translate.instant('MI_PHYSICAL_LOCATION'), icon: 'pi pi-fw pi-bookmark', routerLink: ['mi-physical-location']}
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/cxen')) {
            this.model = [
                {
                    label: this.translate.instant('CXEN'),
                    items: [
                        { label: this.translate.instant('MI_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/cxen'] },
                        // { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['xen/tank-stage1'] },
                        // { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['xen/tank-stage2'] },
                    ]
                },

            ];
        }
        else if (this.router.url.startsWith('/admin')) {
            this.model = [
                {
                    label: this.translate.instant('SUBSIDY_CALCULATION'),
                    items: [
                        { label: this.translate.instant('MI_SURVEY_APPLICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin'] },
                        { label: this.translate.instant('TANK_STAGE1_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/pond/tank-stage1'] },
                        { label: this.translate.instant('TANK_STAGE2_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/pond/tank-stage2'] },
                        { label: this.translate.instant('TANK_STAGE3_SURVEY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/pond/tank-stage3'] },

                    ]
                },
                {
                    label: this.translate.instant('REPORTS'),
                    items: [
                        { label: this.translate.instant('TIME_LINE'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/timeline'] },
                        { label: this.translate.instant('MI_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/consolidated-report'] },
                        { label: this.translate.instant('POND_CONSOLIDATED_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/pond-consolidated-report'] },
                        { label: this.translate.instant('APP_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/app-verification'] },
                        { label: this.translate.instant('VENDOR_PRE_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/pre-estimation'] },
                        { label: this.translate.instant('VENDOR_ESTIMATES'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/estimation'] },
                        { label: this.translate.instant('VENDOR_ESTIMATION_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/estimation-verification'] },
                        { label: this.translate.instant('CHALLAN_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/challan'] },
                        { label: this.translate.instant('BILL_OF_QUANTITY_SUBMISSION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/boq'] },
                        { label: this.translate.instant('APP_PHYSCICAL_VERIFICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/physical-verification'] },
                        { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/fsv'] },
                        { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stv'] },
                        { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stf'] },
                        { label: this.translate.instant('RETURN_OF_EXCESS_FARMER_SHARE_TO_FARMER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/rtf'] },
                        { label: this.translate.instant('MI_VERIFICATION_SUBSIDY_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/mi-verification-subsidy-report'] },
                        { label: this.translate.instant('VENDOE_MI_AREA'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/vendor-mi-area-report'] },
                        { label: this.translate.instant('TANK_ABSTRACT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/tank-abstract-report'] },
                        { label: this.translate.instant('TANK_STAGE1'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage1-report'] },
                        { label: this.translate.instant('TANK_STAGE2'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage2-report'] },
                        { label: this.translate.instant('TANK_STAGE3'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage3-report'] },
                        { label: this.translate.instant('TANK_STAGE1_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage1-subsidy-report'] },
                        { label: this.translate.instant('TANK_STAGE2_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage2-subsidy-report'] },
                        { label: this.translate.instant('TANK_STAGE3_SUBSIDY'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/stage3-subsidy-report'] },
                        { label: this.translate.instant('CANAL_AND_TUBE_WELL_BASED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/canal-and-tube-well-based-report'] },
                        { label: this.translate.instant('CHALLAN_RECONCILIATION_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/chalan-reconciliation-day-report'] },
                        { label: this.translate.instant('7500_DEMO'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/7500-demo'] },
                        { label: this.translate.instant('ATAL_BHUJAL_USER'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/report/atal-bhujal-user'] },
                    ]
                },
                {
                    label: this.translate.instant('CM DASHBOARD'),
                    items: [
                            { label:this.translate.instant('YEAR_WISE_PROGRESS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/year-wise-progress'] },
                            { label:this.translate.instant('MI_AREA_COVERED'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/mi-area-covered'] },
                            { label:this.translate.instant('REAL_TIME_DATA_OF_PDMC_SCHEME'), icon: 'pi pi-fw pi-id-card', routerLink: ['/admin/realtime-data-pdmc-scheme'] }
                        ],
                }
            ];
        }
        else if (this.router.url.startsWith('/cao')) {
            this.model = [
                {
                    label: this.translate.instant('EXPORT_PFMS_DATA'),
                    items: [
                        // { label: 'MI Survey Subsidy Disbursement', icon: 'pi pi-fw pi-id-card', routerLink: ['/mi-survey-subsidy-disbursement'] },
                        { label: this.translate.instant('FARMER_SHARE_TO_VENDOR'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/mi-farmer-share-to-vendor/pfms'] },
                        { label: this.translate.instant('SUBSIDY_TO_FARMER'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/mi-subsidy-to-farmer/pfms'] },
                        { label: this.translate.instant('SUBSIDY_TO_VENDOR'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/mi-subsidy-to-vendor/pfms'] },
                        { label: this.translate.instant('REFUND_TO_FARMER'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/mi-refund-to-farmer/pfms'] },
                        { label: this.translate.instant('TANK1_SUBSIDY_DISBURSEMENT'), icon: 'pi pi-fw pi-check-square', routerLink: ['/cao/pond/tank-stage1/pfms'] },
                        { label: this.translate.instant('TANK2_SUBSIDY_DISBURSEMENT'), icon: 'pi pi-fw pi-check-square', routerLink: ['/cao/pond/tank-stage2/pfms'] },
                        { label: this.translate.instant('TANK3_SUBSIDY_DISBURSEMENT'), icon: 'pi pi-fw pi-check-square', routerLink: ['/cao/pond/tank-stage3/pfms'] },
                    ]
                },
                {
                    label: this.translate.instant('IMPORT_PFMS_DATA'),
                    items: [
                        { label: this.translate.instant('IMPORT_PFMS_EXCEL_SHEETS'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/import/pfms'] },
                    ]
                },
                // {
                //     label: this.translate.instant('IMPORT_BANK_TRANSACTION'),
                //     items: [
                //         { label: this.translate.instant('IMPORT_BANK_EXCEL_SHEETS'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/cao/import/bank-transaction'] },
                //     ]
                // },
                {
                    label: this.translate.instant('REPORTS'),
                    items: [
                        { label: this.translate.instant('CHALLAN_RECONCILIATION_REPORT'), icon: 'pi pi-fw pi-id-card', routerLink: ['/cao/report/chalan-reconciliation-day-report'] },
                    ]
                },
                {
                    label: this.translate.instant('HELPDESK'),
                    items: [
                            { label: this.translate.instant('APPLICATION_STATUS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/cao/helpdesk'] },
                     ],
                },
            ];
        }
        else if (this.router.url.startsWith('/dev')) {
            this.model = [
                {
                    label: this.translate.instant('QUERY'),
                    items: [
                        { label: this.translate.instant('Request Solar'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/dev/request-solar'] },
                        { label: this.translate.instant('Solar Procedure'), icon: 'pi pi-fw pi-id-card', routerLink: ['/dev/solar-procedure'] },
                        { label: this.translate.instant('Solar Flow'), icon: 'pi pi-fw pi-check-square', routerLink: ['/dev/solar-flow'] },
                        { label: this.translate.instant('Modify Solar'), icon: 'pi pi-fw pi-id-card', routerLink: ['/dev/modify-solar'] },
                        { label: this.translate.instant('Get Solar'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/dev/get-solar'] },
                        { label: this.translate.instant('Solar List'), icon: 'pi pi-fw pi-id-card', routerLink: ['/dev/solar-list'] },
                    ]
                }
            ];
        }
        else if (this.router.url.startsWith('/subdev')) {
            this.model = [
                {
                    label: this.translate.instant('QUERY'),
                    items: [
                        { label: this.translate.instant('Request Solar'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/subdev/request-solar'] },
                        { label: this.translate.instant('Solar Flow'), icon: 'pi pi-fw pi-check-square', routerLink: ['/subdev/solar-flow'] },
                        { label: this.translate.instant('Get Solar'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/subdev/get-solar'] },
                    ]
                }
            ];
        }
        else {
            this.model = [
                {
                    label: this.translate.instant('HOME'),
                    items: [
                        { label: this.translate.instant('DASHBOARDS'), icon: 'pi pi-fw pi-home', routerLink: ['/dashboard'] },
                        // {label: 'Pond Progress Intimation',icon: 'pi pi-fw pi-book', routerLink: ['/pond-progress-intimation']}
                    ]
                },
                {
                    label: this.translate.instant('REGISTRATION'),
                    items: [
                        { label: this.translate.instant('PERSONAL_DETAILS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/personal-details'] },
                        { label: this.translate.instant('BANK_DETAILS'), icon: 'pi pi-fw pi-check-square', routerLink: ['/bank-details'] },
                        { label: this.translate.instant('LAND_DETAILS'), icon: 'pi pi-fw pi-bookmark', routerLink: ['/farmer-land-detail'] },
                        { label: this.translate.instant('EXISTING_ON_FARM_MI_DETAILS'), icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/on-farm-mi'] }
                    ]
                },
                {
                    label: this.translate.instant('APPLICATION'),
                    items: [
                        { label: this.translate.instant('ADD_APPLICATION'), icon: 'pi pi-fw pi-id-card', routerLink: ['/farmers-application'] },
                        // {label: 'View Farmers Application', icon: 'pi-file-pdf', routerLink: ['/view-farmers-application']}

                        // {label: 'Bank Details', icon: 'pi pi-fw pi-check-square', routerLink: ['/bank-details']},
                        // {label: 'Farmers Land Details', icon: 'pi pi-fw pi-bookmark', routerLink: ['/farmer-land-detail']},
                        // {label: 'On-Farm MI', icon: 'pi pi-fw pi-exclamation-circle', routerLink: ['/on-farm-mi']}
                    ]
                },
                {
                    label: this.translate.instant('Pond_Water_Tank_Progress_Stage'),
                    items: [
                        { label: this.translate.instant('POND_WATER_TANK_INTIMATION'), icon: 'pi pi-fw pi-book', routerLink: ['/pond-progress-intimation'] }
                    ]
                },
                {
                    label: this.translate.instant('PAYMENT_CHALLAN_DETAILS'),
                    items: [
                        { label: this.translate.instant('SANCTION_LETTER_'), icon: 'pi pi-fw pi-book', routerLink: ['/sanction/sanctio-letter-comp'] },
                        { label: this.translate.instant('MI_CHALLAN'), icon: 'pi pi-fw pi-book', routerLink: ['/challan/mi-challan'] },
                        { label: this.translate.instant('SOLAR_PUMP_CHALLAN'), icon: 'pi pi-fw pi-book', routerLink: ['/challan/solar-challan'] },
                    ]
                },
                // {
                //     label: this.translate.instant('CHANGES_REQUESTS'),
                //     items: [
                //         { label: this.translate.instant('CHANGES_REQUESTS'), icon: 'pi pi-fw pi-id-card', routerLink: ['/change-request'] },
                //     ]
                // }
            ];
        }

    }
    onKeydown(event: KeyboardEvent) {
        const nodeElement = (<HTMLDivElement>event.target);
        if (event.code === 'Enter' || event.code === 'Space') {
            nodeElement.click();
            event.preventDefault();
        }
    }
}
